import { createReducer, on } from '@ngrx/store';
import { setUserListPageNumber, setUserListItemsPerPage } from './../actions/user-management.action';

export interface UserManagementState {
    pageNumberUserList: number;
    itemsPerPageUserList: number;
}

export const initialState: UserManagementState = {
    pageNumberUserList: 1,
    itemsPerPageUserList: 10,
    
};

export const userManagementReducer = createReducer(
    initialState,
    on(setUserListPageNumber, (state, { pageNumberUserList }) => ({ ...state, pageNumberUserList })),
    on(setUserListItemsPerPage, (state, { itemsPerPageUserList }) => ({ ...state, itemsPerPageUserList }))
);